// External Dependencies
import { type Ref, forwardRef } from 'react';
import Card, { type CardProps } from '@mui/material/Card';

// Component Definition
const EnhancedCard = forwardRef<HTMLDivElement, CardProps>((
  props: CardProps,
  ref: Ref<HTMLDivElement>,
): JSX.Element => {
  const { children, ...otherProps } = props;

  return (
    <Card
      {...otherProps}
      ref={ref}
      variant="outlined"
    >
      {children}
    </Card>
  );
});

export default EnhancedCard;
